// @flow
import React from 'react';
import { connect } from 'react-redux';
import PlayableItemPreview from './PlayableItemPreview';
import { ENTITY_TYPE_PLAYLIST } from '../../constants';
import type { Playlist } from '../../shapes/types';
import * as analyticsActions from '../../actions/analytics';

type OwnProps = {
  playlist: Playlist,
  onClick?: Function,
};

type DispatchProps = {
  trackPlayPausePressed: Function,
};

type Props = OwnProps & DispatchProps;

const PlaylistListItem = ({ playlist, trackPlayPausePressed, onClick }: Props) => {
  const beforeTogglePlay = (item, playing) => {
    trackPlayPausePressed(
      {
        contextId: item.id,
        contextType: 'playlist',
      },
      playing
    );
  };

  return (
    <PlayableItemPreview
      item={{
        content: { ...playlist, type: ENTITY_TYPE_PLAYLIST },
        ...playlist,
      }}
      beforeTogglePlay={beforeTogglePlay}
      showPlayButton
      onClick={onClick}
    />
  );
};

const dispatchProps: DispatchProps = {
  trackPlayPausePressed: analyticsActions.trackPlayPausePressed,
};

export default connect(null, dispatchProps)(PlaylistListItem);
